import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../context/TranslationContext';

interface TranslatedTextProps {
  children: string;
  component?: React.ElementType;
  [key: string]: any; // Allow any other props to be passed through
}

const TranslatedText: React.FC<TranslatedTextProps> = ({ 
  children, 
  component: Component = 'span',
  ...otherProps 
}) => {
  const { translateText } = useTranslation();
  const [translatedText, setTranslatedText] = useState<string>(children);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const performTranslation = async () => {
      setIsLoading(true);
      try {
        const result = await translateText(children);
        setTranslatedText(result);
      } catch (error) {
        console.warn('Translation error:', error);
        setTranslatedText(children); // Fallback to original
      } finally {
        setIsLoading(false);
      }
    };

    performTranslation();
  }, [children, translateText]);

  return (
    <Component {...otherProps}>
      {isLoading ? children : translatedText}
    </Component>
  );
};

export default TranslatedText;